import React, { Dispatch, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'
import Breadcrumb from './breadcrumb/Breadcrumb'
import Element from 'react-scroll/modules/components/Element'
import Questions from './questions/Questions'
import { Sticky, StickyContainer } from 'react-sticky'
import { useMediaQuery } from 'react-responsive'
import { newsEnum } from '../../enums/newsEnum'
import fetchFactory from '../../utils/fetchFactory'
import { RootState } from '../reducers'
import { NewsType } from '../reducers/news/types'
import { NewsModel } from '../../types/news/newsModel'
import { saveNews, setLoadingNews } from '../reducers/news/actions'
import errorCatcher from '../../utils/errorCatcher'
import { connect, useDispatch, useSelector } from 'react-redux'
import Loader from '../../components/loader/Loader'
import Exploitation from '../../components/news/Exploitation'
import EmptyState from '../../components/news/EmptyState'
import Marketing from '../../components/news/Marketing'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            titleStyle: {
                margin: '0 0 40px'
            },
            secondSubTitleStyle: {
                margin: '50px 0 40px'
            },
            questionsSmallScreenStyle: {
                marginBottom: 20
            }
        }
    )
)

const COMPONENT_NAME = 'news'

const News = () => {
    const classes = useStyle()
    const intl = useIntl()
    const news = useSelector((state: RootState) => state.news)
    const dispatch = useDispatch()

    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )
    const offset = isLargeScreen ? 150 : 65

    const titleClass: ClassValue = classNames(
        classes.title1,
        classes.colorBlue,
        classes.titleStyle
    )

    const subTitleClass: ClassValue = classNames(
        classes.title2,
        classes.colorBlue,
        classes.titleStyle
    )

    const secondSubTitleClass: ClassValue = classNames(
        subTitleClass,
        classes.secondSubTitleStyle
    )

    useEffect(
        () => {
            if (news.loading || (news.locale && news.locale !== intl.locale)) {
                fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/information/getNews?language=${intl.locale}`)
                    .then(
                        (news: any) => {
                            dispatch(
                                saveNews({ ...news, locale: intl.locale })
                            )
                        }
                    )
                    .catch(
                        (err) => {
                            dispatch(
                                errorCatcher(err, COMPONENT_NAME)
                            )
                        }
                    )
                    .finally(
                        () => {
                            dispatch(
                                setLoadingNews(false)
                            )
                        }
                    )
            }
        }, [dispatch, intl.locale, news.loading, news.locale]
    )

    const NewsList = () => (
        <>
            <Element
                name={newsEnum.actualite_exploitation}
            >
                <h1 className={subTitleClass}>
                    <FormattedMessage
                        id="news.breadcrumb.actualite_exploitation"
                        defaultMessage="Informations pratiques"
                        description="Exploitation title"
                    />
                </h1>

                {
                    news.actualite_exploitation.length > 0 &&
					<Exploitation newsExploitation={news.actualite_exploitation} />
                }
                {
                    news.actualite_exploitation.length === 0 &&
					<EmptyState />
                }
            </Element>

            <Element
                name={newsEnum.actualite_marketing}
            >
                <h1 className={secondSubTitleClass}>
                    <FormattedMessage
                        id="news.breadcrumb.actualite_marketing"
                        defaultMessage="La vie de votre résidence"
                        description="Marketing title"
                    />
                </h1>

                {
                    news.actualite_marketing.length > 0 &&
					<Marketing newsMarketing={news.actualite_marketing} />
                }
                {
                    news.actualite_marketing.length === 0 &&
					<EmptyState />
                }
            </Element>
        </>
    )

    return (
        <>
            {
                news.loading ? (
                    <Loader />
                ) : (
                    <>
                        <h1 className={titleClass}>
                            <FormattedMessage
                                id="news.title"
                                defaultMessage="Actualités"
                                description="News title"
                            />
                        </h1>

                        <div className="row between-md">
                            <StickyContainer className="col-xs-12 col-md-3">
                                <Sticky
                                    topOffset={-offset}
                                    bottomOffset={offset}
                                >
                                    {
                                        (
                                            {
                                                style,
                                                distanceFromBottom,
                                                isSticky
                                            }
                                        ) => (
                                            <div
                                                style={{
                                                    ...style,
                                                    top: isSticky && (distanceFromBottom < 0) ? 'auto' : offset,
                                                    zIndex: 2,
                                                    bottom: isSticky && (distanceFromBottom < 0) ? 243 : 'auto'
                                                }}
                                            >
                                                <Breadcrumb offset={isLargeScreen ? offset : offset + 160} />

                                                {
                                                    isLargeScreen &&
													<Questions />
                                                }
                                            </div>
                                        )
                                    }
                                </Sticky>

                                {
                                    !isLargeScreen &&
									<>
										<div className={classes.questionsSmallScreenStyle}>
											<Questions />
										</div>

										<NewsList />
									</>
                                }

                            </StickyContainer>

                            {
                                isLargeScreen &&
								<div className="col-md-8">
									<NewsList />
								</div>
                            }
                        </div>
                    </>
                )
            }
        </>
    )
}

const mapStateToProps = (state: RootState) => (
    {
        news: state.news
    }
)

const mapDispatchToProps = (dispatch: Dispatch<NewsType | any>) => (
    {
        saveNews: (news: NewsModel) => {
            dispatch(saveNews(news))
        },
        errorCatcher: (error: any, id: string) => {
            dispatch(errorCatcher(error, id))
        }
    }
)

export default connect(mapStateToProps, mapDispatchToProps)(News)
